"use client";

import { useTranslations } from "next-intl";

export default function BookCallButton() {
    const t = useTranslations();

    const handleClick = (e) => {
        const target = document.getElementById("reserver");
        if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <a
            href="#reserver"
            onClick={handleClick}
            className="btn-landing inline-flex items-center bg-primary hover:opacity-90 transition-opacity rounded-xl px-6 py-3.5 font-semibold shadow-sm"
        >
            {t("BookNewCall_button_bookACall")}
        </a>
    );
}
